// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre[data-v-29783d24]{background:none;color:#647b8d}h2[data-v-29783d24]{font-size:medium;margin:3ch 0 1ch 0}", ""]);
// Exports
module.exports = exports;
